import React from 'react';
import { FadeIn } from './FadeIn';
import { Clock, MousePointerClick, UserCheck } from 'lucide-react';
export function BeforeAfter() {
  const stats = [{
    icon: <Clock size={24} className="text-accent" strokeWidth={1.75} data-id="element-13" />,
    value: '+150 hs',
    label: 'ahorradas al año'
  }, {
    icon: <MousePointerClick size={24} className="text-accent" strokeWidth={1.75} data-id="element-14" />,
    value: 'Clics',
    label: 'y clases listas'
  }, {
    icon: <UserCheck size={24} className="text-accent" strokeWidth={1.75} data-id="element-15" />,
    value: '100%',
    label: 'de profesional a profesional'
  }];
  return <section className="py-10 px-3" data-id="element-16">
      <div className="max-w-4xl mx-auto" data-id="element-17">
        <FadeIn className="text-center mb-8" data-id="element-18">
          <div className="inline-flex items-center gap-2 md:gap-4 bg-accent/10 border border-accent/30 rounded-full px-6 py-2.5 shadow-[0_0_30px_rgba(184,153,104,0.35)]" data-id="element-19">
            <span className="text-accent font-bold text-sm md:text-base" data-id="element-20">
              Organizado
            </span>
            <span className="text-accent/40 text-lg" data-id="element-21">·</span>
            <span className="text-accent font-bold text-sm md:text-base" data-id="element-22">
              Visual
            </span>
            <span className="text-accent/40 text-lg" data-id="element-23">·</span>
            <span className="text-accent font-bold text-sm md:text-base" data-id="element-24">
              Listo para imprimir
            </span>
          </div>
        </FadeIn>

        <FadeIn className="grid grid-cols-3 gap-2 md:gap-4 mt-8" data-id="element-25">
          {stats.map((stat, idx) => <div key={idx} className="bg-surface/60 border border-accent/20 rounded-2xl p-3 md:p-6 text-center flex flex-col items-center gap-2 md:gap-3 shadow-sm hover:border-accent/40 transition-colors" data-id="element-26">
              <div className="bg-accent/10 p-2 md:p-3 rounded-xl" data-id="element-27">
                {stat.icon}
              </div>
              <div data-id="element-28">
                <p className="text-ink font-bold text-base md:text-3xl leading-tight font-display" data-id="element-29">
                  {stat.value}
                </p>
                <p className="text-muted text-[11px] md:text-sm mt-1 leading-snug" data-id="element-30">
                  {stat.label}
                </p>
              </div>
            </div>)}
        </FadeIn>
      </div>
    </section>;
}